import { FormDocument } from './form-document.type';

export interface SearchOptions {
  document: FormDocument ;
  filter: any;
  includeDeleted: boolean;
  searchOfflineOnly: boolean;
}
